import { render, staticRenderFns } from "./ManageOrders.vue?vue&type=template&id=446fd811&lang=pug&"
import script from "./ManageOrders.vue?vue&type=script&lang=js&"
export * from "./ManageOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports